import { type TTab } from '@cian/ui-kit';

import { EMortgageOffersTabs } from '../../../enums/EMortgageOffersTabs';

interface IGetMortgageOffersTabsParams {
  hasBanks: boolean;
  hasMortgagePromos: boolean;
}

type SectionTab = TTab & {
  value: EMortgageOffersTabs;
};

export function getSectionTabs({ hasBanks, hasMortgagePromos }: IGetMortgageOffersTabsParams): SectionTab[] {
  const tabs: SectionTab[] = [];

  if (hasMortgagePromos) {
    tabs.push({ text: 'Ипотечные предложения', value: EMortgageOffersTabs.Mortgage });
  }

  if (hasBanks) {
    tabs.push({ text: 'Аккредитованные банки', value: EMortgageOffersTabs.Banks });
  }

  return tabs;
}
